import React, { useState, useEffect, useRef } from "react";
import { Button } from "reactstrap";
import { useAlertas } from "../../context/AlertasContext";

const AlertasVisualizacoes = () => {
    const [showPopup, setShowPopup] = useState(false);
    const { alertas = [], marcarVisualizado, permissaoExibirAlerta } = useAlertas();
    const popupRef = useRef(null);

    const togglePopup = () => setShowPopup(!showPopup);

    const abrirOrdem = (ordemId) => {
        const url = '/mapaordem/analiseordemmap?id=' + ordemId;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const badgeText = alertas.length > 99 ? "99+" : alertas.length;

    // Fechar popup se clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };

        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);

    if (!permissaoExibirAlerta) return null;

    return (
        <div style={{ position: "relative", marginRight: "20px" }}>
            <div style={{ cursor: "pointer", position: "relative" }} onClick={togglePopup}>
                <i
                    className="fa fa-bell"
                    style={{ color: alertas.length > 0 ? "red" : "white", fontSize: "20px" }}
                />
                <span
                    style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-12px",
                        background: "red",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        fontSize: "10px",
                        minWidth: "18px",
                        textAlign: "center",
                        lineHeight: "14px",
                        fontWeight: "bold",
                    }}
                >
                    {badgeText}
                </span>
            </div>

            {showPopup && (
                <div
                    ref={popupRef}
                    style={{
                        position: "fixed",
                        top: "60px",
                        right: "20px",
                        width: "400px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        background: "white",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        padding: "10px",
                        zIndex: 9999999999999,
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
                    }}
                >
                    <h5>Alertas</h5>
                    {alertas.length === 0 ? (
                        <p>Nenhum alerta encontrado.</p>
                    ) : (
                        alertas.map((a) => (
                            <div
                                key={a.ordemColetaInconformidadeId}
                                style={{ borderBottom: "1px solid #eee", padding: "8px 0" }}
                            >
                                <p><b>Plano:</b> {a?.planoTrabalhoIdentificacao ?? "Ordem Avulsa"}</p>
                                <p><b>Placa:</b> {a.placaVeiculo}</p>
                                <p><b>Data/Hora:</b> {new Date(a.dataHoraAlerta).toLocaleString("pt-BR")}</p>
                                <div className="d-flex gap-2">
                                    <Button
                                        size="sm"
                                        color="primary"
                                        onClick={() => abrirOrdem(a.ordemColetaId)}
                                    >
                                        Abrir Ordem
                                    </Button>
                                    <Button
                                        size="sm"
                                        color="success"
                                        onClick={() => {
                                            marcarVisualizado(a.ordemColetaInconformidadeId)
                                            setShowPopup(false)
                                        }}
                                    >
                                        Marcar como Visualizado
                                    </Button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default AlertasVisualizacoes;
